import React from "react";
import StorageIconSVG from "../../assets/icons/svg/StorageIconSVG";
import ArrowDownIcon from "../../assets/icons/svg/ArrowDownSVG";

const ArchivePart = ({ onClick, count, showArchived }) => (
  <div onClick={onClick} style={styles.container(showArchived)}>
    <ArrowDownIcon width={20} height={20} />
    <div style={styles.iconWrapper}>
      <StorageIconSVG width={24} height={24} />
    </div>
    <div style={styles.text}>
      Arhivirani zahtevi ({count})
    </div>
  </div>
);

export default ArchivePart;

const styles = {
  container: (showArchived) => ({
    marginTop: "24px",
    marginLeft: "25px",
    display: "flex",
    alignItems: "center",
    padding: "16px 16px",
    border: "1px solid #ccc",
    borderRadius: "10px",
    backgroundColor: showArchived ? "#000" : "#f5f5f5",
    color: showArchived ? "#fff" : "#000",
    cursor: "pointer",
    width: "1000px",
  }),
  iconWrapper: {
    margin: "0 12px",
  },
  text: {
    fontWeight: 600,
    fontSize: "16px",
  },
};
